import * as React from 'react';
import { useRouter } from 'next/router';
import { AuthCardFromCase } from '@/components/auth/AuthCardFromCase';
import { Button, Typography } from '@/components/common';
import AppRoutes from '@/const/routes';

interface ClaimEvaluatedProps {
	isApproved: boolean;
}

export const ClaimEvaluated: React.FC<ClaimEvaluatedProps> = ({
	isApproved,
}) => {
	const router = useRouter();
	const { evaluated, case_id } = router.query;
	const signUpRoute = `${AppRoutes.CLIENTAPP_AUTH_SIGN_UP}?evaluated=${evaluated}&case_id=${case_id}`;

	return isApproved ? (
		<AuthCardFromCase
			title={
				<>
					You may <span className="text-primary">qualify</span> for this case!
				</>
			}
			subtitle="Based on your responses, it looks like you could be eligible for compensation"
			imageSrc="/img/landing/svg/girl-excited.svg"
			signInLink={true}
		>
			<div className="flex flex-col gap-8">
				<Typography
					type="regular-18"
					className="text-center max-w-[560px] m-auto"
				>
					Create your free account to confirm and track your claim
				</Typography>
				<Button
					size="fit"
					label="Create My Account"
					decoration="primary"
					className="m-auto"
					href={signUpRoute}
				/>
			</div>
		</AuthCardFromCase>
	) : (
		<AuthCardFromCase
			title="You may not qualify for this claim right now"
			subtitle="But there are other cases to explore"
			imageSrc="/img/landing/svg/guy-phone.svg"
			signInLink={true}
		>
			<div className="flex flex-col gap-8">
				<Typography
					type="regular-18"
					className="text-center max-w-[560px] m-auto"
				>
					Create a free account to explore all and automatically check your
					eligibility next time.
				</Typography>
				<Button
					size="fit"
					label="Create My Account"
					decoration="primary"
					className="m-auto"
					href={signUpRoute}
				/>
			</div>
		</AuthCardFromCase>
	);
};
